export default __webpack_public_path__ + "static/gogokoza-e9fdd375b22fa14c0055853cc8ccd365.png";